import React from 'react';
interface SectionTagProps {
  icon?: string;
  children: React.ReactNode;
  tone?: 'flash' | 'gray';
}
export function SectionTag({
  icon,
  children,
  tone = 'flash'
}: SectionTagProps) {
  return <span className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs sm:text-sm font-bold uppercase tracking-wider ${tone === 'flash' ? 'border-flash/25 bg-flash/10 text-flash' : 'border-slate-200 bg-slate-100 text-muted'}`} data-id="element-296" data-mp="3no1lqb6fsce8">
      {icon && <span aria-hidden="true" data-id="element-297" data-mp="3sne9qz91npie">{icon}</span>}
      {children}
    </span>;
}